// import _Loading from 'assets/scripts/_app/cuchillo/layout/Loading';

export default class Loading /*extends _Loading*/ {
  static start() { document.body.classList.add("--loading"); }
  static stop() { document.body.classList.remove("--loading"); }
}


